export const actionTypes = {
  FETCH_TRANSACTIONS: 'FETCH_TRANSACTIONS',
  SET_TRANSACTIONS: 'SET_TRANSACTIONS',
  CONFIRM_PAYMENT: 'CONFIRM_PAYMENT',
  GENERATE_BATCH_SETTLEMENT: 'GENERATE_BATCH_SETTLEMENT',
  GENERATE_BATCH_SETTLEMENT_SUCCESS: 'GENERATE_BATCH_SETTLEMENT_SUCCESS',
  GENERATE_BATCH_SETTLEMENT_FAILURE: 'GENERATE_BATCH_SETTLEMENT_FAILURE',
};

export const fetchTransactions = () => ({
  type: actionTypes.FETCH_TRANSACTIONS,
});

export const setTransactions = data => ({
  type: actionTypes.SET_TRANSACTIONS,
  data,
});

export const confirmPayment = (documentId) => ({
  type: actionTypes.CONFIRM_PAYMENT,
  documentId,
});

export const generateBatchSettlement = (serviceProviderId, startDate, endDate, invoices) => ({
  type: actionTypes.GENERATE_BATCH_SETTLEMENT,
  payload: {
    serviceProviderId,
    startDate,
    endDate,
    invoices,
  },
});

